import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/graphql'

import { useCustomTimeRange } from 'modules/attendance/hooks/useCustomTimeRange'
import { useAttendanceSettingWorkCategories } from 'modules/attendance/lib/attendanceSettingWorkCategoriesContext'
import CustomTimeRangeUtils from 'modules/attendance/lib/utils/CustomTimeRangeUtils'

import Cell from './Cell'

const TableBody = () => {
  const { dayEnums } = useCustomTimeRange()
  const { customTimeRanges } = useAttendanceSettingWorkCategories()

  const timeRangesByStartTime = CustomTimeRangeUtils.timeRangesByStartTime(customTimeRanges)
  const sortedStartTimes = CustomTimeRangeUtils.sortedStartTimes(timeRangesByStartTime)
  const hasCustomTypeTimeRanges = CustomTimeRangeUtils.hasCustomTypeTimeRanges(customTimeRanges)
  const hasBaseTypeTimeRanges = CustomTimeRangeUtils.hasBaseTypeTimeRanges(customTimeRanges)
  const hasTimeRanges = CustomTimeRangeUtils.hasTimeRanges(customTimeRanges)
  const baseTypeTimeRanges = CustomTimeRangeUtils.baseTypeTimeRanges(customTimeRanges)
  const timeRangesByType = CustomTimeRangeUtils.getAllTimeRangesByType(baseTypeTimeRanges)

  const renderEmptyRow = () => (
    <Table.Row background="grey100">
      {dayEnums.map((day) => (
        <Table.Cell key={`empty_${day}`} noBorder>
          <Cell timeRanges={[]} dayType={day} base showNotDefined />
        </Table.Cell>
      ))}
    </Table.Row>
  )

  if (!hasTimeRanges) {
    return <Table.Body>{renderEmptyRow()}</Table.Body>
  }

  const renderBaseTypeRows = () =>
    Object.entries(timeRangesByType).map(([timeType, rangesByType], index) => {
      if (rangesByType.length === 0) return null
      return (
        <Table.Row key={timeType} background="grey100">
          {dayEnums.map((day: AttendanceCustomTimeRangeDayEnum) => (
            <Table.Cell key={`${timeType}_${day}`} noBorder>
              <Cell
                timeRanges={CustomTimeRangeUtils.rangesInSpecificBaseDay(rangesByType, day)}
                dayType={day}
                base
                showNotDefined={
                  index === 0 && !CustomTimeRangeUtils.hasRangesInSpecificDay(customTimeRanges, day)
                }
              />
            </Table.Cell>
          ))}
        </Table.Row>
      )
    })

  const renderCustomTypeRows = () =>
    sortedStartTimes.map((startTime, index) => (
      <Table.Row key={startTime} background="grey100">
        {dayEnums.map((day) => (
          <Table.Cell key={`time_slot_${day}`} noBorder verticalAlign="top">
            <Box paddingTop={!hasBaseTypeTimeRanges && index === 0 ? 's12' : undefined}>
              <Cell
                timeRanges={CustomTimeRangeUtils.rangesInSpecificCustomDay(
                  timeRangesByStartTime[startTime] ?? [],
                  day
                )}
                dayType={day}
                showNotDefined={
                  !hasBaseTypeTimeRanges &&
                  index === 0 &&
                  !CustomTimeRangeUtils.hasRangesInSpecificDay(customTimeRanges, day)
                }
              />
            </Box>
          </Table.Cell>
        ))}
      </Table.Row>
    ))

  return (
    <Table.Body>
      {hasBaseTypeTimeRanges && renderBaseTypeRows()}
      {hasCustomTypeTimeRanges && renderCustomTypeRows()}
    </Table.Body>
  )
}

export default TableBody
